import { css } from '@emotion/react'
import type { ReactNode } from 'react'

type Props = {
  lnb?: ReactNode
  children: ReactNode
}

const LnbPageLayout = ({ lnb, children }: Props) => (
  <div css={S.row}>
    {lnb}
    <div css={S.content}>{children}</div>
  </div>
)

export default LnbPageLayout

const S = {
  row: css`
    display: flex;
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
  `,
  content: css`
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    min-width: 0;
    height: 100%;
    overflow: hidden;
  `,
}
